import type { PacketSourceResolved } from "../../lib/api";
import { FileText } from "lucide-react";

/** Q42: generic packet fallback renderer.
 *
 *  Used when the source kind doesn't have a dedicated view
 *  (obsidian, manual capture, rss, voice transcript, linkedin,
 *  …). Shows the packet text body verbatim plus the meta-derived
 *  header. */

export function GenericPacketView({ resolved }: { resolved: PacketSourceResolved }) {
  const { header, body } = resolved.render;
  return (
    <div className="px-4 sm:px-6 py-4 space-y-3">
      <section className="space-y-1">
        {header.subject && (
          <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
            {header.subject}
          </h1>
        )}
        <div className="text-xs text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
          <FileText className="w-3.5 h-3.5" />
          {header.when ? new Date(header.when).toLocaleString() : ""}
          {resolved.packet.source_kind && (
            <span className="ml-1 text-slate-400 lowercase">{resolved.packet.source_kind}</span>
          )}
        </div>
      </section>

      {body.text ? (
        <article className="text-sm text-slate-800 dark:text-slate-100 whitespace-pre-wrap leading-relaxed">
          {body.text}
        </article>
      ) : body.snippet ? (
        <article className="text-sm text-slate-500 dark:text-slate-400 italic">
          {body.snippet}
        </article>
      ) : (
        <p className="text-sm text-slate-500 italic">(No body captured.)</p>
      )}
    </div>
  );
}
